module.exports = __webpack_public_path__ + "assets/images/popups/ph_symbol.png";